/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Next_Fine_Stork_WishInputs */

const fr_next_fine_stork_wish = /** @type {(inputs: Next_Fine_Stork_WishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier mon nom d'utilisateur`)
};

/**

* @param {Next_Fine_Stork_WishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const next_fine_stork_wish = /** @type {((inputs?: Next_Fine_Stork_WishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_Fine_Stork_WishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_next_fine_stork_wish(inputs)
});